import script from "./FaqView.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqView.vue?vue&type=script&setup=true&lang=js"

import "./FaqView.vue?vue&type=style&index=0&id=35c35cf0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35c35cf0"]])

export default __exports__